"use client";

import Link from "next/link";

interface NavItem {
  label: string;
  href: string;
  status?: boolean;
}

interface NavigationMenuProps {
  links: NavItem[];
}

export default function NavMenu({ links }: NavigationMenuProps) {
  return (
    <nav className="hidden text-16 md:flex gap-10">
      {links
        .filter((item) => item.status)
        .map((item) => (
          <Link
            key={item.label}
            href={item.href}
            className="font-medium text-primary hover:text-secondary transition"
          >
            {item.label}
          </Link>
        ))}
    </nav>
  );
}
